
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/immigration-service",
      function () {
        return require("private-next-pages/vn/immigration-service/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vn/immigration-service"])
      });
    }
  